import { Link, useLocation } from 'react-router-dom';
import usePageMeta from '@/hooks/usePageMeta';

export default function NotFound() {
  const location = useLocation();

  usePageMeta({
    title: '页面走丢了｜高校吃瓜社',
    description: '你访问的页面暂时不存在，回到首页或事件合集继续围观校园热门现场。',
    keywords: '高校吃瓜,高校吃瓜事件,页面未找到',
    canonicalPath: '/',
  });

  return (
    <div className="mx-auto flex w-full max-w-3xl flex-col items-center px-4 py-20 text-center md:px-6 md:py-28">
      <span className="flex h-16 w-16 items-center justify-center rounded-full bg-primary-100 text-primary-600">
        <i className="ri-compass-3-line text-3xl leading-none" aria-hidden="true"></i>
      </span>
      <h1 className="mt-5 font-heading text-3xl font-black text-foreground-950 md:text-4xl">这个页面走丢了</h1>
      <p className="mt-3 text-sm text-foreground-500">{location.pathname}</p>
      <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600 md:text-base">
        你要找的内容可能已经调整了位置。回到首页看看今天大家都在围观什么吧。
      </p>
      <div className="mt-7 flex flex-col gap-3 sm:flex-row">
        <Link
          to="/"
          className="inline-flex items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
        >
          <i className="ri-home-5-line text-base leading-none" aria-hidden="true"></i>
          返回首页
        </Link>
        <Link
          to="/events"
          className="inline-flex items-center justify-center gap-1.5 whitespace-nowrap rounded-md border border-foreground-300 px-5 py-2.5 text-sm font-semibold text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-600"
        >
          去事件合集
          <i className="ri-arrow-right-line text-base leading-none" aria-hidden="true"></i>
        </Link>
      </div>
    </div>
  );
}